export default "__VITE_ASSET__DAx8NlFv__"